import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class GlobalFlowAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare state: StateService;

  get canVisit(): boolean {
    return this.canEdit;
  }

  get canEdit(): boolean {
    if (!this.state.visitorsSubscription?.canAccessGlobalSignInFlows) return false;

    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_GLOBAL_FLOW_UPDATE);
  }
}
